/* eslint-disable class-methods-use-this */
import Backbone from 'backbone';
import selectors from './selectors';

// The cart item view.
class CartItemView extends Backbone.View {
  get tagName() {
    return 'tr';
  }

  get className() {
    return 'vtc-resource-item';
  }

  get template() {
	const { template } = selectors;
    return _.template(
      $(template.item).html(),
    );
  }

  get events() {
    return {
      'click .vtc-cart-collection-check': 'toggleDone',
    };
  }

  initialize() {
    this.listenTo(this.model, 'change', this.render);
    this.listenTo(this.model, 'destroy', this.remove);
  }

  toggleDone() {
    this.model.toggle();
  }

  render() {
    this.$el.html(this.template(this.model.toJSON()));
    return this;
  }
}

export default CartItemView;
